import React from "react";
import "./InboxThread.scss";

const InboxThread = ({ children }) => <div className="inbox-thread">{children}</div>;

export default InboxThread;
